import * as Msal from "msal";

const jwtDecode = require("jwt-decode");

const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID || "",
    authority: process.env.VUE_APP_MSAL_AUTHORITY || "",
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URL || "",
    validateAuthority: true,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

const loginRequest = {
  scopes: ["openid", "profile"],
};

const apiTokenRequest = {
  scopes: [`api://${process.env.VUE_APP_MSAL_SCOPE_ID}/access_user`],
};

var graphTokenRequest = {
  scopes: ["User.Read"],
};

const state = () => ({
  loggedInUser: null,
  myMSALObj: null,
  provider: null,
});

const getters = {};

const mutations = {
  signedIn(state) {
    state.provider.setState(this.$mgt.ProviderState.SignedIn);
  },

  // Init MSAL
  initMsal(state) {
    if (!state.myMSALObj) {
      state.myMSALObj = new Msal.UserAgentApplication(msalConfig); // eslint-disable-line
    }
  },
};

const actions = {
  async logOut({ state, commit }) {
    try {
      state.myMSALObj.logout();
    } catch (err) {
      // Silence is golden!
    }

    // Log the user out no matter what.
    this.$sCache.clear("loggedIn");
    document.location = "/";
  },

  //Login myMSALObj.getAccount().userName
  async signIn({ state, dispatch }, returnToken) {
    try {
      await state.myMSALObj.loginPopup(loginRequest);
      if (state.myMSALObj.getAccount()) {
        if (returnToken) {
          return dispatch("getToken");
        }
        return true;
      }
      console.warn(
        "Something happened trying to authenticate your request, you might not have permissions to sign-in as an administrator."
      );
      return false;
    } catch (err) {
      console.warn(err.message);
      console.log(err);
      return false;
    }
  },

  async getApiToken({ state, commit, dispatch }) {
    if (state.myMSALObj.getAccount()) {
      try {
        let accesTokenScopes = apiTokenRequest;
        const response = await state.myMSALObj.acquireTokenSilent(
          accesTokenScopes
        );
        commit("signedIn");
        return response.accessToken;
      } catch (err) {
        console.log(err);
        // Silently failed, let's try with a popup
        return await dispatch("getTokenWithPopup", apiTokenRequest);
      }
    } else {
      // TODO: No token acquired, need to log the user
      return dispatch("signIn", true);
    }
  },

  async getToken({ state, commit, dispatch }, scope) {
    if (state.myMSALObj.getAccount()) {
      try {
        let accesTokenScopes = graphTokenRequest || scope;
        const response = await state.myMSALObj.acquireTokenSilent(
          accesTokenScopes
        );
        commit("signedIn");
        return response.accessToken;
      } catch (err) {
        console.log(err);
        // Silently failed, let's try with a popup
        return await dispatch("getTokenWithPopup");
      }
    } else {
      // TODO: No token acquired, need to log the user
      return dispatch("signIn", true);
    }
  },

  async getTokenWithPopup({ state, commit }, scope) {
    try {
      let accesTokenScopes = graphTokenRequest || scope;
      const response = await state.myMSALObj.acquireTokenPopup(
        accesTokenScopes
      );
      commit("signedIn");
      return response.accessToken;
    } catch (err) {
      console.warn(err.message);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
